import {
  init_imageProcessingDeclaration
} from "./chunk-TWLTOH7G.mjs";
import {
  init_imageProcessingFunctions
} from "./chunk-SXELSWMR.mjs";
import {
  init_helperFunctions
} from "./chunk-DW4SJM6G.mjs";
import {
  ShaderStore,
  init_shaderStore
} from "./chunk-74QERPGX.mjs";
import {
  __esm
} from "./chunk-AU4RG7EN.mjs";

// node_modules/@babylonjs/core/Shaders/imageProcessing.fragment.js
var name, shader, imageProcessingPixelShader;
var init_imageProcessing_fragment = __esm({
  "node_modules/@babylonjs/core/Shaders/imageProcessing.fragment.js"() {
    init_shaderStore();
    init_imageProcessingDeclaration();
    init_helperFunctions();
    init_imageProcessingFunctions();
    name = "imageProcessingPixelShader";
    shader = `varying vec2 vUV;uniform sampler2D textureSampler;
#include<imageProcessingDeclaration>
#include<helperFunctions>
#include<imageProcessingFunctions>
#define CUSTOM_FRAGMENT_DEFINITIONS
void main(void)
{vec4 result=texture2D(textureSampler,vUV);
#ifdef IMAGEPROCESSING
#ifndef FROMLINEARSPACE
result.rgb=toLinearSpace(result.rgb);
#endif
result=applyImageProcessing(result);
#else
#ifdef FROMLINEARSPACE
result=applyImageProcessing(result);
#endif
#endif
gl_FragColor=result;}`;
    ShaderStore.ShadersStore[name] = shader;
    imageProcessingPixelShader = { name, shader };
  }
});

export {
  imageProcessingPixelShader,
  init_imageProcessing_fragment
};
